import { curry } from 'lib/util'
import { redirect } from 'app/_shared/events'
import { jump } from 'app/_shared/events/step'
import update from 'app/_shared/events/util/update'

/**
 * Redirects to the component's route and jumps to the step with index `index`.
 *
 * @param {number} index                the index of the step to jump to
 * @param {Gaia.AppModule.Spec} module  the current module composition object
 * @param {Gaia.Component.Spec} component  the current action's main component
 * @param {Event} event                 the event object that triggered this handler
 * @returns {Promise<void>} void
 */
// eslint-disable-next-line no-unused-vars
const redirectAndJumpTo = async (index, module, component, event) => {
  await redirect(module, component, event)
  await jump(module, component, { index })
  await update(module, component, event)
}

export default curry(redirectAndJumpTo)
